import React, { ReactNode } from 'react'

import './ChatMessageLabelComponent.scss'

interface ChatMessageLabelComponentProps {
  children: string | ReactNode
  style?: {
    color: string
    background: string
  }
}

const ChatMessageLabelComponent = ({
  children,
  style,
}: ChatMessageLabelComponentProps) => (
  <div style={style} className="chat-message-label-component">
    {children}
  </div>
)

export default ChatMessageLabelComponent
